import { Button, Form } from "react-bootstrap";
import Message from "../message";
import { useState } from "react";

function Elasticsearch() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [elasticsearch, setElasticsearch] = useState("");
  const [status_elasticsearch, setStatus_elasticsearch] = useState("");

  const submit_mca = async () => {
    setStatus_elasticsearch("");

    if (elasticsearch.length <= 0) {
      setStatus_elasticsearch("Upload some files!");
    } else {
      const gst_formData = new FormData();
      gst_formData.set("file", elasticsearch);

      const requestOptions = {
        method: "POST",
        body: gst_formData,
      };

      try {
        const gst_response = await fetch(
          apiServer + `api/elasticsearch/upload_file`,
          requestOptions
        );
        const gst_status_id = await gst_response.json();
        const gst_status = gst_status_id.detail
          ? gst_status_id.detail
          : gst_status_id;

        setStatus_elasticsearch(gst_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Button
        style={{
          marginBottom: "15px",
          width: "100%",
          backgroundColor: "#3a4c7a",
          border: "none",
        }}
        href="./templates/ES-Input.csv"
        download
      >
        Download Template
      </Button>
      <Form.Control
        type="file"
        onChange={(e) => setElasticsearch(e.target.files[0])}
      />
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submit_mca()}
      >
        Submit
      </Button>
      {Message(status_elasticsearch, setStatus_elasticsearch)}
    </div>
  );
}

export default Elasticsearch;
